/* tslint:disable */
/* eslint-disable */

/**
 * partnerDriverWeb driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

import { GeneratedApiClient, GeneratedHttpClientConstraints, RequestOptionsConstraint, HttpMethod, AuthStrategy, ShardingStrategy } from "../runtime";

import type {
    DriverRegistrationLogStep,
    FleetUploadedDocument,
    GetActualDriverRegistrationResponse,
    GetAvailableSupportOptionsResponse,
    GetDocumentCaptureModeResponse,
    GetMqttConnectionInfoResponse,
    GetSupportCaseWidgetUrlResponse,
    GetSupportWidgetUrlResponse,
    GetUnreadCasesWithLastMessageResponse,
    TriggerDocumentUploadRequest,
    TriggerDocumentUploadResponse,
    StandardRequest,
} from '../models/index';

export interface HttpClientConstraints {
    Auth: AuthStrategy.JWT;
    Sharding: ShardingStrategy.NONE;
    StandardRequest: StandardRequest;
}

export interface DriverRegistrationSupportGetAvailableSupportOptionsRequest {
    step: DriverRegistrationLogStep;
}
export interface GetCaptureModeRequest {
    hash: string;
    app_version?: string;
}
export interface UploadDriverRegistrationDocumentRequest {
    hash: string;
    expires?: string;
}


class ApiClientClass<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> extends GeneratedApiClient<THttpClientConstraints, TRequestOptions> {
        public driverRegistrationGetMqttConnectionInfo = async (opts?: TRequestOptions): Promise<GetMqttConnectionInfoResponse>  => {
            return this.httpClient.sendRequest<GetMqttConnectionInfoResponse>({
                path: '/driverRegistration/getMqttConnectionInfo',
                service_id: 'driver-registration-portal',
                subdomain: 'partnerdriverweb',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public driverRegistrationGetSupportCaseWidgetUrl = async (opts?: TRequestOptions): Promise<GetSupportCaseWidgetUrlResponse>  => {
            return this.httpClient.sendRequest<GetSupportCaseWidgetUrlResponse>({
                path: '/driverRegistration/getSupportCaseWidgetUrl',
                service_id: 'driver-registration-portal',
                subdomain: 'partnerdriverweb',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public driverRegistrationGetUnreadCasesWithLastMessage = async (opts?: TRequestOptions): Promise<GetUnreadCasesWithLastMessageResponse>  => {
            return this.httpClient.sendRequest<GetUnreadCasesWithLastMessageResponse>({
                path: '/driverRegistration/getUnreadCasesWithLastMessage',
                service_id: 'driver-registration-portal',
                subdomain: 'partnerdriverweb',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public driverRegistrationSupportGetAvailableSupportOptions = async (query: DriverRegistrationSupportGetAvailableSupportOptionsRequest, opts?: TRequestOptions): Promise<GetAvailableSupportOptionsResponse>  => {
            return this.httpClient.sendRequest<GetAvailableSupportOptionsResponse>({
                path: '/driverRegistration/support/getAvailableSupportOptions',
                service_id: 'driver-registration-portal',
                subdomain: 'partnerdriverweb',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public driverRegistrationSupportGetSupportWidgetUrl = async (opts?: TRequestOptions): Promise<GetSupportWidgetUrlResponse>  => {
            return this.httpClient.sendRequest<GetSupportWidgetUrlResponse>({
                path: '/driverRegistration/support/getSupportWidgetUrl',
                service_id: 'driver-registration-portal',
                subdomain: 'partnerdriverweb',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public getActualRegistration = async (opts?: TRequestOptions): Promise<GetActualDriverRegistrationResponse>  => {
            return this.httpClient.sendRequest<GetActualDriverRegistrationResponse>({
                path: '/partnerDriverWeb/getActualRegistration',
                service_id: 'driver-registration-portal',
                subdomain: 'partnerdriverweb',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public getCaptureMode = async (query: GetCaptureModeRequest, opts?: TRequestOptions): Promise<GetDocumentCaptureModeResponse>  => {
            return this.httpClient.sendRequest<GetDocumentCaptureModeResponse>({
                path: '/partnerDriverWeb/getCaptureMode',
                service_id: 'driver-registration-portal',
                subdomain: 'partnerdriverweb',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public triggerDocumentUpload = async (body: TriggerDocumentUploadRequest, opts?: TRequestOptions): Promise<TriggerDocumentUploadResponse>  => {
            return this.httpClient.sendRequest<TriggerDocumentUploadResponse>({
                path: '/partnerDriverWeb/triggerDocumentUpload',
                service_id: 'driver-registration-portal',
                subdomain: 'partnerdriverweb',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public uploadDriverRegistrationDocument = async (query: UploadDriverRegistrationDocumentRequest, opts?: TRequestOptions): Promise<FleetUploadedDocument>  => {
            return this.httpClient.sendRequest<FleetUploadedDocument>({
                path: '/partnerDriverWeb/uploadDriverRegistrationDocument',
                service_id: 'driver-registration-portal',
                subdomain: 'partnerdriverweb',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
}
// Split class actual prototype and type
export const ApiClient = ApiClientClass;
/**
 * When you use ApiClient class as a type it would include private / protected properties which leads
 * to a situation where 2 sources of the ApiClient are not equal.
 *
 * This situation can happen for example when a library depends on the whole ApiClient and consumer wants to pass
 * in its own ApiClient. That would lead to an error
 *
 * TS2345: Argument of type 'ApiClient<HttpClientConstraints, HttpRequestOpts>' is not assignable to parameter of type 'ApiClient<HttpClientConstraints, never>'.
 *  Property 'apiClientOptions' is protected but type 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>' is not a class derived from 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>'.
 */
export type ApiClient<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> = {
    [Key in keyof ApiClientClass<THttpClientConstraints, TRequestOptions>]: ApiClientClass<THttpClientConstraints, TRequestOptions>[Key];
};
